import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    width:100%;
    @media (max-width: 767px){
        width: unset;
        padding-left: 20px;
        padding-right: 20px;
    }
    margin: 46px 0 0;
    padding: 16px 6px 5px 7px;
    border-radius: 5px;
    background-color: #f5f5f5;

    @media (max-width: 992px) {
        margin-bottom: 60px;
    }
`;

export const RangeContainer = styled.div`
    box-sizing:border-box;
    padding: 3px 15px;
    .input-range {
        .input-range__track{
            background-color:#ebebeb;
            display:block;
            height:8px;

            .input-range__track--active {
                ${'' /* background-color: #ee2527; */}
                ${({ ml }) => css`
                    margin-left: ${ml}%;
                `}
                height:8px;
            }
            .input-range__slider{
                top:-9px;
                background-color:#fff;
                ${'' /* background-image: url('${window._env_.STATIC_HOST}/static/website/images/icons/icon-input-range.svg'); */}
                height: 36px;
                width: 36px;
                z-index:1;
                &:active{
                    transform:none;
                }
                border:none;
                box-shadow:0 0 10px #ccc;
                @media (max-width: 767px){
                    margin-left: -0.9rem;
                }
            }
            .input-range__label{
                font-family: Nunito;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                color: #333333;
            }
            .input-range__label--value{
                top: auto;
                bottom: -1.8rem;
            }
        }
        .input-range__label--max, .input-range__label--min {
            display:none;
        }
    }
`;

export const Labels = styled.div`
    width:100%;
    display:flex;
    justify-content:space-between;
    div{
        display:inline-block;
        box-sizing:border-box;
        padding:0 5px;
        span{
            display:block;
            font-family: Nunito;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            color: #333333;
        }
    }
`;

export const Price = styled.span`
  font-size: 23px !important;
  line-height: 1.04 !important;
  letter-spacing: -0.29px !important;
  margin: 5px 0;

  @media (max-width: 992px) {
      font-size: 18px !important;
  }
`;

export const Range = styled.div`
    display: flex;
    justify-content: space-between;
    align-items:center;
    .input-range{
        margin:auto 3px;
    }
`;